import axios from "axios";
import VueCookies from "vue-cookies";
import router from "../router";
axios.interceptors.request.use(function (config) {
  return config;
});

axios.interceptors.response.use(function (response) {
  return Promise.resolve(response.data);
});
const baseURL = process.env.VUE_APP_API;
const instance = axios.create({
  withCredentials: true,
  baseURL: baseURL,
  responseType: "json"
});

instance.interceptors.request.use(
  function (config) {
    config.headers.common["API-KEY"] = process.env.VUE_APP_API_KEY;
    return config;
  },
  function (error) {
    console.log(error, "erorr");
  }
);

instance.interceptors.response.use(
  function (response, config) {
    return Promise.resolve(response.data);
  },
  function (error, config) {
    if (error.response.status == 401) {
      VueCookies.remove("token");
      router.go();
    }
    return Promise.reject(error.response);
  }
);

export { instance, axios };
